import { render, staticRenderFns } from "./ArtistDeptPanel.vue?vue&type=template&id=38554d36&scoped=true"
import script from "./ArtistDeptPanel.vue?vue&type=script&lang=js"
export * from "./ArtistDeptPanel.vue?vue&type=script&lang=js"
import style0 from "./ArtistDeptPanel.vue?vue&type=style&index=0&id=38554d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38554d36",
  null
  
)

export default component.exports